import React from 'react';
import './PopupModal.css';

const PopupModal = ({ isOpen, onClose, title, message }) => {
  if (!isOpen) return null;

  return (
    <div className="popup-modal-overlay" onClick={onClose}>
      <div className="popup-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="popup-modal-header">
          <h2>{title}</h2>
          <button className="popup-modal-close-btn" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="popup-modal-body">
          <p>{message}</p>
        </div>
        <div className="popup-modal-footer">
          <button className="popup-modal-btn-close" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopupModal;
